import { render, staticRenderFns } from "./wordcloud.vue?vue&type=template&id=1e51a3e7&scoped=true&"
import script from "./wordcloud.vue?vue&type=script&lang=js&"
export * from "./wordcloud.vue?vue&type=script&lang=js&"
import style0 from "./wordcloud.vue?vue&type=style&index=0&id=1e51a3e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51a3e7",
  null
  
)

export default component.exports